import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { AppState } from 'src';
import { CoverageNLimitsComponentProperties, CoverageNLimitsComponent } from './coverage-n-limits.component';
import { saveFormData } from '../../../../vendor.actions';
import { VendorViewModel } from '@models/Vendor';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: { buttonRef: (button: HTMLButtonElement) => void; next?: Function; currentStep: number }
): Partial<CoverageNLimitsComponentProperties> {
  return {
    vendorVM: state.vendor.vendorVM,
    buttonRef: ownProps.buttonRef
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: {
    buttonRef: (button: HTMLButtonElement) => void;
    currentStep: number;
    next?: Function;
  }
): Partial<CoverageNLimitsComponentProperties> {
  return {
    onSaveClick: (model: VendorViewModel) => {
      dispatch(saveFormData(model));
      if (ownProps.next) {
        ownProps.next();
      }
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CoverageNLimits = connect(
  mapStateToProps,
  mapDispatchToProps
)(CoverageNLimitsComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/steps/coverage-n-limits/coverage-n-limits.container.ts